module.exports = __webpack_public_path__ + "static/media/new_apartment.38044d08.png";